import { styled } from '@mui/material/styles';
import { Select, Checkbox } from '@mui/material';
import { SxProps, Theme } from '@mui/material';

interface StyledRoleSelectProps {
  height?: string;
  width?: string;
  hasError?: boolean;
}

export const StyledRoleSelect = styled(Select, {
  shouldForwardProp: (prop) =>
    prop !== 'height' && prop !== 'width' && prop !== 'hasError',
})<StyledRoleSelectProps>(
  ({ height = '40px', width = '450px', hasError = false }) => ({
    height: height,
    width: width,
    backgroundColor: 'var(--text-bg)',
    border: 'none',
    borderRadius: '4px',
    color: 'var(--primary-navy)',

    '& .MuiSelect-select': {
      padding: '10px 14px',
      fontFamily: 'Outfit',
      fontSize: '16px',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: hasError ? 'var(--error)' : 'var(--border)',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--primary-blue)',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--primary-blue)',
    },

    '& input': {
      fontFamily: 'Outfit',
      fontSize: '16px',
    },

    overflow: 'hidden',

    '& input:-webkit-autofill': {
      backgroundColor: 'var(--bg-color)',
      WebkitBoxShadow: '0 0 0 30px var(--bg-color) inset',
    },
  })
);

export const StyledRoleCheckbox = styled(Checkbox)({
  width: '24px',
  height: '24px',
  color: 'var(--instructions)',
  padding: 0,

  '& .MuiSvgIcon-root': {
    fontSize: '16px',
  },

  '&.Mui-checked': {
    color: 'var(--primary-blue)',
  },
});

export const roleSelectMenuProps = {
  PaperProps: {
    sx: {
      mt: 0.5,
      borderRadius: 2,
      border: '1px solid var(--border)',
      bgcolor: 'var(--text-bg)',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
  },
};

export const roleChevronIconStyles: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  right: '12px',
  transform: 'translateY(-50%)',
  fontSize: '16px',
  color: 'var(--instructions)',
  '&:hover': {
    cursor: 'pointer',
  },
};

export const roleLabelStyles: SxProps<Theme> = {
  fontFamily: 'Outfit',
  fontWeight: '400',
  fontSize: '16px',
  color: 'var(--primary-navy)',
  mb: 2,
};

export const roleListItemTextStyles = (
  isSelected: boolean
): SxProps<Theme> => ({
  '& .MuiTypography-root': {
    fontFamily: 'Outfit',
    fontWeight: 400,
    fontSize: '16px',
    marginLeft: 2,
    color: isSelected ? 'var(--primary-blue)' : 'var(--primary-navy)',
  },
});

export const roleErrorIconStyles: SxProps<Theme> = {
  fontSize: '16px',
  color: 'var(--error)',
  mr: 0.8,
};
